import { render, staticRenderFns } from "./AssistanceSuiviDossier.vue?vue&type=template&id=6cdcb545&"
import script from "./AssistanceSuiviDossier.vue?vue&type=script&lang=js&"
export * from "./AssistanceSuiviDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports